import React from "react";
import { useTranslation } from "react-i18next";

interface CustomPaginationProps {
  pageCount: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  pageCount,
  currentPage,
  onPageChange,
}) => {
  const { t } = useTranslation();

  if (pageCount <= 1) return null;

  const pages = [];
  for (let i = 0; i < pageCount; i++) {
    pages.push(
      <button
        key={i}
        onClick={() => onPageChange(i)}
        className={`px-3 py-1 rounded border border-gray-300 mx-1 ${
          currentPage === i
            ? "bg-[#AA232F] text-white"
            : "bg-white text-gray-700 hover:bg-[#AA232F] hover:text-white transition"
        }`}
        disabled={currentPage === i}
      >
        {i + 1}
      </button>,
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-8">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
        className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 hover:bg-[#AA232F] hover:text-white transition disabled:opacity-50"
      >
        ← {t("prev")}
      </button>
      {pages}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === pageCount - 1}
        className="px-3 py-1 rounded border border-gray-300 bg-white text-gray-700 hover:bg-[#AA232F] hover:text-white transition disabled:opacity-50"
      >
        {t("next")} →
      </button>
    </div>
  );
};

export default CustomPagination;
